import { query as Q } from "@/app-utils/graphql/query.ts";
import {
  ExecuteWorkflowDocument,
  type ExecuteWorkflowMutation,
  type ExecuteWorkflowMutationVariables,
  GetActivitiesDocument,
  type GetActivitiesQuery,
  type GetActivitiesQueryVariables,
  GetProjectFilesFromSampleAttributeDocument,
  type GetProjectFilesFromSampleAttributeQuery,
  type GetProjectFilesFromSampleAttributeQueryVariables,
  GetWorkflowEventDetailsDocument,
  type GetWorkflowEventDetailsQuery,
  type GetWorkflowEventDetailsQueryVariables,
  ImportTemplateToWorkflowEventDocument,
  type ImportTemplateToWorkflowEventMutation,
  type ImportTemplateToWorkflowEventMutationVariables,
  LoadWorkflowDocument,
  LoadWorkflowEventDocument,
  type LoadWorkflowEventQuery,
  type LoadWorkflowEventQueryVariables,
  type LoadWorkflowQuery,
  type LoadWorkflowQueryVariables,
  PublishWorkflowDocument,
  type PublishWorkflowMutation,
  type PublishWorkflowMutationVariables,
  PublishWorkflowTemplateDocument,
  type PublishWorkflowTemplateMutation,
  type PublishWorkflowTemplateMutationVariables,
  ResetWorkflowDocument,
  type ResetWorkflowMutation,
  type ResetWorkflowMutationVariables,
  SaveWorkflowEventDocument,
  type SaveWorkflowEventMutation,
  type SaveWorkflowEventMutationVariables,
  StopWorkflowDocument,
  type StopWorkflowMutation,
  type StopWorkflowMutationVariables,
} from "@/modules/workflow/graphql/workflow.gql.ts";
import {
  CheckWorkflowNameDocument,
  type CheckWorkflowNameQuery,
  type CheckWorkflowNameQueryVariables,
  ValidatePlaybookPublishPermissionsDocument,
  type ValidatePlaybookPublishPermissionsQuery,
  type ValidatePlaybookPublishPermissionsQueryVariables,
} from "@/modules/workflow/graphql/workflow-validation.gql.ts";

// TODO Check how errors are managed and deactivate `showAlert` if issues are already covered
export const getActivitiesQuery = Q<GetActivitiesQuery, GetActivitiesQueryVariables>(GetActivitiesDocument);
export const loadWorkflowQuery = Q<LoadWorkflowQuery, LoadWorkflowQueryVariables>(LoadWorkflowDocument, {
  showAlert: false,
});
export const loadWorkflowEventQuery = Q<LoadWorkflowEventQuery, LoadWorkflowEventQueryVariables>(
  LoadWorkflowEventDocument,
  {
    showAlert: false,
  },
);

export const getWorkflowEventDetails = Q<GetWorkflowEventDetailsQuery, GetWorkflowEventDetailsQueryVariables>(
  GetWorkflowEventDetailsDocument,
);

export const checkWorkflowNameQuery = Q<CheckWorkflowNameQuery, CheckWorkflowNameQueryVariables>(
  CheckWorkflowNameDocument,
);
export const publishWorkflowTemplateMutation = Q<
  PublishWorkflowTemplateMutation,
  PublishWorkflowTemplateMutationVariables
>(PublishWorkflowTemplateDocument);
export const saveWorkflowEventMutation = Q<SaveWorkflowEventMutation, SaveWorkflowEventMutationVariables>(
  SaveWorkflowEventDocument,
);

export const importTemplateToWorkflowEventMutation = Q<
  ImportTemplateToWorkflowEventMutation,
  ImportTemplateToWorkflowEventMutationVariables
>(ImportTemplateToWorkflowEventDocument);

export const executeWorkflowMutation = Q<ExecuteWorkflowMutation, ExecuteWorkflowMutationVariables>(
  ExecuteWorkflowDocument,
);

export const stopWorkflowMutation = Q<StopWorkflowMutation, StopWorkflowMutationVariables>(StopWorkflowDocument);
export const resetWorkflowMutation = Q<ResetWorkflowMutation, ResetWorkflowMutationVariables>(ResetWorkflowDocument);
export const publishWorkflowMutation = Q<PublishWorkflowMutation, PublishWorkflowMutationVariables>(
  PublishWorkflowDocument,
);
export const validatePublishingParameters = Q<
  ValidatePlaybookPublishPermissionsQuery,
  ValidatePlaybookPublishPermissionsQueryVariables
>(ValidatePlaybookPublishPermissionsDocument);

export const getProjectFilesFromSampleAttribute = Q<
  GetProjectFilesFromSampleAttributeQuery,
  GetProjectFilesFromSampleAttributeQueryVariables
>(GetProjectFilesFromSampleAttributeDocument);
